import React from 'react'
import {withRouter} from "react-router-dom";

export function PushToInvite (props) {
  const {history: {push}} = props
  push('/invite')
}

export default withRouter(PushToInvite)
